import {
    calculateDownPayment,
    getAppliedDealerSettings,
    getDealInfo,
    getSelectedPricingDetails,
} from '@atc/wallet-payment-fns';

const getDeal = (listing, payments, nationalRates, isNDSCalc, cashDealPrice = null, disableTrade = false) => {
    if (payments && listing) {
        const {
            id: listingId,
            paymentServices: { dealerSettings = {} } = {},
            pricingDetail = {},
            type: vehicleCondition = 'used',
        } = listing;

        const { interactions: walletInteractions = {} } = payments;

        const { paymentDetails, downPayment, selectedPricingDetails, price } = getSelectedPricingDetails(
            payments,
            listingId,
            pricingDetail,
            cashDealPrice
        );

        const {
            downPaymentPercent,
            downPayment: downPaymentValue,
            ...restSettings
        } = getAppliedDealerSettings({ dealerSettings, walletInteractions, price, payments, nationalRates });

        const paymentsWithSettings = {
            ...payments,
            ...restSettings,
        };

        if (downPayment) {
            paymentsWithSettings.downPayment = downPayment;
        } else {
            // Fall back downPayment If PS won't return any downPayment for any reason there will be one in nds as well.
            paymentsWithSettings.downPayment = calculateDownPayment(price, {
                downPayment: downPaymentValue,
                downPaymentPercent,
            });
        }

        const {
            deal = {},
            summary = [],
            estimates = {},
        } = getDealInfo(
            selectedPricingDetails,
            paymentDetails,
            vehicleCondition,
            paymentsWithSettings,
            isNDSCalc,
            !!nationalRates,
            disableTrade
        );

        return { deal, summary, estimates };
    }
    return {};
};

export default getDeal;
